import {useIntl} from "react-intl";

const UseTranslate = () => {
    const intl = useIntl();

    return (id, values = {}) => {
        return intl.formatMessage(
            {id, defaultMessage: id},
            {
                ...values,
                br: <br/>,
                sm: (text) => <span style={{fontSize: 12}}>{text}</span>,
                md: (text) => <span style={{fontSize: 24}}>{text}</span>,
                lg: (text) => <span style={{fontSize: 30}}>{text}</span>,
                xl: (text) => <span style={{fontSize: 38}}>{text}</span>
            }
        );
    };
};

export default UseTranslate;